
<div *ngIf="processing">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>

<div *ngIf="!processing">
    <div class="flex flex-row gap-2 justify-start items-center mb-4">
      <h1 class="portal-page-title">Online payment failed</h1>
    </div>

    <mat-card class="portal-notice" *ngIf="isValid">
      <span >Your online payment has <strong>Failed</strong>.  Please remember: <br/><br />
        <ul>
          <li>Processing of applications and/or application changes will not be processed and/or approved until the payment has cleared. </li>
          <li>You can revisit your <strong><a [routerLink]="['/payments']" >Payments</a></strong> to continue the payment process online or see other payment options. </li>
        </ul>
      </span>
    </mat-card>
  </div>

